import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import profileRoutes from 'modules/Profile/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Notifications = lazy(
  () => import(/* webpackChunkName: "Notifications" */ 'modules/Notifications/pages/Notifications')
)

const NotificationsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={Notifications} />
      <Redirect path='*' to={profileRoutes.root} />
    </Switch>
  </Suspense>
)

export default NotificationsRouting
